import { lightTheme } from '@/customTheme'

function FullscreenIcon({ size = 24, fill = lightTheme.colors.blackGray }: { size?: number; fill?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Design's horizontal "Stretch" chevrons, flipped and turned -45° about the icon centre. */}
      <g transform="translate(12 12) rotate(-45) scale(-1 1) translate(-8.7344 -4.00066)" fill={fill} fillRule="evenodd" clipRule="evenodd">
        <path d="M2.16449 4.00502L4.45021 1.70488C4.83951 1.31313 4.83752 0.679971 4.44577 0.290675C4.05402 -0.0986203 3.42086 -0.0966314 3.03157 0.295118L0.465081 2.87778C-0.15592 3.50269 -0.154895 4.51205 0.467373 5.1357L3.033 7.70704C3.42309 8.09799 4.05625 8.0987 4.44721 7.70861C4.83817 7.31852 4.83887 6.68535 4.44878 6.2944L2.16449 4.00502Z" />
        <path d="M15.3043 4.00561L13.0186 1.70547C12.6293 1.31372 12.6313 0.680561 13.023 0.291266C13.4148 -0.09803 14.0479 -0.096041 14.4372 0.295708L17.0037 2.87837C17.6247 3.50328 17.6237 4.51264 17.0014 5.13629L14.4358 7.70763C14.0457 8.09859 13.4125 8.09929 13.0216 7.7092C12.6306 7.31911 12.6299 6.68594 13.02 6.29499L15.3043 4.00561Z" />
      </g>
    </svg>
  )
}

export default FullscreenIcon
